import {HostBinding, Input} from '@angular/core';

export abstract class AbstractButton {
    @Input() public disabled: boolean;
    @HostBinding('attr.name') @Input() public title: string;

    constructor() {
        this.title = 'N/A';
    }
}
